import View from './Preferences'
import { connect } from 'react-redux'
import { compose } from 'ramda'
import { updateNewsletterSubscription, updatePartnerSubscription } from './../../../store/modules/profile'

const mapStateToProps = state => ({
  locale: state.router.locale,
  user: state.profile.user,
  submitting: state.profile.isUpdatingPreferences,
  error: state.profile.preferencesUpdateError,
  success: state.profile.preferencesUpdateSuccess,
})

const mapDispatchToProps = dispatch => ({
  updateNewsletterSubscription: compose(dispatch, updateNewsletterSubscription),
  updatePartnerSubscription: compose(dispatch, updatePartnerSubscription),
})

const Preferences = connect(mapStateToProps, mapDispatchToProps)(View)

export default Preferences
